import _get from 'lodash/get';

const v3ReverseGeoEndpoint = ({
  latitude,
  longitude,
  pickupOrDropoff = 'dropoff',
  isToggle = true,
}) => {
  const { endpoints } = window.Grab.config;
  const { geWebAPIBase } = endpoints;
  return `${geWebAPIBase}/v3/go-poi/reverse-geo?latitude=${latitude}&longitude=${longitude}&pickupOrDropoff=${pickupOrDropoff}&isToggle=${isToggle}`;
};

const v3SuggestPOIEndpoint = ({
  latitude,
  longitude,
  pickupOrDropoff = 'dropoff',
  isToggle = true,
}) => {
  const { endpoints } = window.Grab.config;
  const { geWebAPIBase } = endpoints;
  return `${geWebAPIBase}/v3/go-poi/suggest?latitude=${latitude}&longitude=${longitude}&pickupOrDropoff=${pickupOrDropoff}&isToggle=${isToggle}`;
};

const v3SearchAddressEndpoint = ({
  keyword,
  latlng,
  pickupOrDropoff,
  isToggle,
}) => {
  const { endpoints } = window.Grab.config;
  const { geWebAPIBase } = endpoints;
  const url = new URL(`${geWebAPIBase}/v3/go-poi/search`);

  url.searchParams.append('keyword', keyword);
  url.searchParams.append('latitude', _get(latlng, 'latitude'));
  url.searchParams.append('longitude', _get(latlng, 'longitude'));

  if (pickupOrDropoff) {
    url.searchParams.append('pickupOrDropoff', pickupOrDropoff);
  }
  if (isToggle !== undefined) {
    url.searchParams.append('isToggle', isToggle);
  }
  return url.toString();
};

const v3ResolvePOIsEndpoint = () => {
  const { endpoints } = window.Grab.config;
  const { geWebAPIBase } = endpoints;
  return `${geWebAPIBase}/v3/go-poi/resolve`;
};

const v3FavoritesPOIsEndpoint = ({ latitude, longitude }) => {
  const { endpoints } = window.Grab.config;
  const { geWebAPIBase } = endpoints;
  const url = new URL(`${geWebAPIBase}/v3/go-poi/favorites`);
  url.searchParams.append('latitude', latitude);
  url.searchParams.append('longitude', longitude);
  return url.toString();
};

const v3PredictPOIsEndpoint = ({
  latitude,
  longitude,
  pickupOrDropoff = 'dropoff',
  isToggle = true,
}) => {
  const { endpoints } = window.Grab.config;
  const { geWebAPIBase } = endpoints;
  const url = new URL(`${geWebAPIBase}/v3/go-poi/predict`);

  url.searchParams.append('latitude', latitude);
  url.searchParams.append('longitude', longitude);
  url.searchParams.append('transportationType', pickupOrDropoff);
  url.searchParams.append('isToggle', isToggle);

  return url.toString();
};

const v3SaveFavoritesPOIsEndpoint = () => {
  const { endpoints } = window.Grab.config;
  const { geWebAPIBase } = endpoints;
  const url = new URL(`${geWebAPIBase}/v3/go-poi/favorites`);
  return url.toString();
};

export default {
  v3ReverseGeoEndpoint,
  v3SuggestPOIEndpoint,
  v3SearchAddressEndpoint,
  v3ResolvePOIsEndpoint,
  v3FavoritesPOIsEndpoint,
  v3PredictPOIsEndpoint,
  v3SaveFavoritesPOIsEndpoint,
};
